/**
 * Channels API client — (tf3-35a; B-F14) the channels are the package's (@vms/publishing): every connected YouTube, TikTok
 * and Instagram account, read through the package's own list, the same store Settings shows. The legacy `channels` table
 * (a name, niche and defaults with no account behind them) is retired; its routes answer 410.
 */
import { apiDelete } from "./client.ts";
import { publishingApi, type PublishChannelView } from "./videos.ts";

export type Channel = PublishChannelView;
/** what a Disconnect did (the package's full disconnect), as Settings reads it */
export type DisconnectAnswer = { ok: boolean; revoked?: boolean; revokeError?: string | null };
const DISCONNECT: Record<string, string> = { youtube: "/youtube/channels", tiktok: "/tiktok/channels", instagram: "/instagram/channels" };

export const channelsApi = {
  /** the owner's connected channels, every platform (a revoked one is gone from here, as from Settings) */
  list: async (): Promise<{ channels: Channel[] }> => ({ channels: (await publishingApi.channels()).channels.filter((c) => c.status !== "revoked") }),
  /** the same Disconnect as Settings: the platform's own route */
  disconnect: (c: Pick<Channel, "channelId" | "channel">) => {
    const base = DISCONNECT[c.channel];
    if (!base) return Promise.reject(new Error(`${c.channel} channels can't be disconnected here`));
    return apiDelete<DisconnectAnswer>(`${base}/${encodeURIComponent(c.channelId)}`);
  },
};
